import { startOfToday, addDays } from 'date-fns'
import { format } from 'date-fns/fp'
import type { DateOffset, DateOffsetsAsStrings } from '@edge/spark/io-dashboards'

const FORMAT = 'yyyy-MM-dd'

const formatAsISODate = format(FORMAT)

/** Offsets are 0-based integers based on today.
 *
 * Past dates are negative, future dates are positive.
 * @param start should be less than end.
 * @param end must be greater than start.
 */
export const getDatesFromOffset = (offset: DateOffset | undefined, fallback: DateOffset): DateOffsetsAsStrings => {
    const today = startOfToday()

    const { start, end } = offset ?? fallback

    return {
        startDate: formatAsISODate(addDays(today, start)),
        endDate: formatAsISODate(addDays(today, end)),
    }
}

export default getDatesFromOffset
